import { SelectMultiple } from '@bloomfieldrobotics/canopy';
import { sizeBucketLabelMap } from './Charts/SizeBucket';

type Props = {
  value: string[];
  onChange: (values: string[]) => void;
};

export const SizeSelect = ({ value, onChange }: Props) => {
  const sizeBuckets = Object.keys(sizeBucketLabelMap);

  const options = sizeBuckets.map((sizeBucket) => ({
    value: sizeBucket,
    label: sizeBucketLabelMap[sizeBucket],
  }));

  return (
    <SelectMultiple
      variant='minimal'
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};
